/* eslint-disable */
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  aiMessage: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1.4em',
  },
  aiMessageAvatar: {
    width: '32px',
    height: '32px',
    border: '1px solid #e3e3e3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    padding: '1em',
  },
  aiMessageResponse: {
    fontSize: '1em',
    marginTop: '.4em',
  },
});

const ChatbotResponse = ({ htmlResponse }) => {
  return <div dangerouslySetInnerHTML={{ __html: htmlResponse }} />;
};

const AiMessage = ({ message = '' }) => {
  const classes = useStyles();

  return (
    <div className={classes.aiMessage}>
      <div className={classes.aiMessageAvatar}>
        <img src="favicon.png" width={16} height={16} />
      </div>
      <div className={classes.aiMessageResponse}>
        <ChatbotResponse htmlResponse={message} />
      </div>
    </div>
  );
};

export default AiMessage;
